import React, { Component } from "react";

export default class RightFloat extends Component {
  render() {
    return (
      <div className="right-float">
        <img
          src="https://static.wixstatic.com/media/17cf82e0d3fc4c11a370a8eedfefa0fb.png/v1/fill/w_31,h_31,al_c,q_85,usm_0.66_1.00_0.01/17cf82e0d3fc4c11a370a8eedfefa0fb.webp"
          alt=""
        />
        <img
          src="https://static.wixstatic.com/media/0fdef751204647a3bbd7eaa2827ed4f9.png/v1/fill/w_31,h_31,al_c,q_85,usm_0.66_1.00_0.01/0fdef751204647a3bbd7eaa2827ed4f9.webp"
          alt=""
        />
        <img
          src="https://static.wixstatic.com/media/01c3aff52f2a4dffa526d7a9843d46ea.png/v1/fill/w_31,h_31,al_c,q_85,usm_0.66_1.00_0.01/01c3aff52f2a4dffa526d7a9843d46ea.webp"
          alt=""
        />
      </div>
    );
  }
}
